import React from 'react';
import { getDotSize } from '../../../helpers/functions';
import { PublishingTimeMap } from '../../../helpers/types';

const counties = [
    'Troms og Finnmark',
    'Nordland',
    'Trøndelag',
    'Møre og Romsdal',
    'Vestland',
    'Rogaland',
    'Agder',
    'Vestfold og Telemark',
    'Oslo',
    'Viken',
    'Innlandet',
];

const MapSvg = ({ data }: { data: PublishingTimeMap[] }) => {
    if (data) {
        const existingCounties = data.map((item) => item.county);

        counties.forEach((countyName) => {
            if (!existingCounties.includes(countyName)) {
                data.push({ county: countyName, standingTime: null });
            }
        });
    }

    const sortedData: PublishingTimeMap[] = data?.sort((a, b) => {
        if (a.standingTime && b.standingTime) {
            return a.standingTime - b.standingTime;
        }
        if (a.standingTime === null && b.standingTime !== null) {
            return b.standingTime;
        }
        if (a.standingTime !== null && b.standingTime === null) {
            return a.standingTime;
        }
        return 0;
    });

    const coordinates: { [key: string]: { x: number; y: number } } = {
        'Troms og Finnmark': { x: 125, y: 15 },
        Nordland: { x: 85, y: 35 },
        Trøndelag: { x: 65, y: 75 },
        'Møre og Romsdal': { x: 30, y: 100 },
        Vestland: { x: 15, y: 110 },
        Rogaland: { x: 8, y: 133 },
        Agder: { x: 15, y: 159 },
        'Vestfold og Telemark': { x: 31, y: 151 },
        Oslo: { x: 44, y: 135 },
        Viken: { x: 51, y: 131 },
        Innlandet: { x: 54, y: 108 },
    };

    const radius: Map<string, number> = new Map([
        ['xsmall', 2],
        ['small', 4],
        ['medium', 6],
        ['large', 8],
        ['xlarge', 12],
    ]);

    return (
        <svg width="180" height="180" viewBox="0 -5 155 190" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.7633 163.124C22.209 166.246 26.5401 159.748 35.19 154.407C42.7809 149.72 37.7428 141.857 42.6585 141.092C46.359 145.769 42.7319 152.429 48.7709 156.157C54.8191 159.879 52.7317 147.973 57.075 142.849C62.8018 136.094 61.4091 129.335 64.0476 123.048C66.1075 118.16 61.804 106.162 64.372 96.1651C67.7297 83.0953 73.6677 89.6302 75.8716 83.2698C77.7387 77.5858 70.6192 78.0082 76.447 68.7981C81.2127 61.2716 82.2411 57.2955 88.2067 52.0952C93.1959 47.7243 91.2339 38.6245 96.5811 37.0175C101.919 35.3953 101.509 38.7071 105.412 37.241C109.302 35.7779 103.845 29.4114 109.825 27.027C115.62 24.6977 117.906 33.7241 123.293 34.6821C132.739 36.3839 133.978 25.3956 139.323 23.3019C144.59 21.2389 153.393 32.5671 158.379 25.3955C162.101 20.0575 152.12 18.6587 151.661 16.262C150.966 12.4635 159.769 10.526 152.803 4.94919C147.728 0.884406 141.658 7.28155 139.485 6.0266C137.706 5.00429 138.628 -0.113425 127.471 0.067164C118.892 0.204901 115.167 5.42362 109.727 8.01308C104.215 10.6362 99.0359 9.03234 94.9528 13.0849C89.7739 18.2301 94.1661 20.9788 89.4127 24.3426C86.5783 26.323 82.1187 23.7764 73.1046 27.7157C65.679 30.9724 56.2761 39.0744 57.5831 42.1934C58.9115 45.2971 77.9835 36.7849 77.959 40.2987C77.9499 43.0657 73.0097 46.4327 66.3707 59.0892C64.7301 62.1898 45.1316 82.4464 45.5448 84.9624C46.1386 88.614 52.9551 85.0879 56.0618 82.0791C58.7799 79.4498 58.2748 85.0328 54.3661 87.1693C51.1094 88.9507 51.0145 92.4706 49.3158 91.9197C48.1802 91.5493 47.8588 88.5742 43.7604 88.6079C39.5211 88.6507 35.0615 86.6612 32.6893 88.0202C29.7938 89.6669 27.4553 92.5257 23.2711 94.4663C17.024 97.3649 10.6391 99.8411 8.08635 103.373C6.0662 106.171 1.84838 116.29 3.37573 118.457C4.46845 120.006 7.19259 117.799 10.8197 119.412C13.2286 120.477 20.2348 119.412 20.4246 120.174C20.5592 120.701 14.6335 122.721 10.5014 122.081C6.62634 121.487 3.1829 121.129 2.23098 122.528C0.422029 125.182 -0.477855 133.529 0.859728 135.788C1.59433 137.036 3.25024 136.149 5.72951 135.699C8.27613 135.246 11.5359 135.748 11.3492 136.256C11.19 136.718 8.00371 137.153 5.41425 137.82C3.15535 138.408 1.11684 139.363 0.988283 139.819C0.584254 141.346 0.746478 147.654 1.7841 149.95C2.35035 151.202 5.53362 150.082 6.23761 151.989C6.87426 153.709 4.0736 154.915 4.71026 157.526C5.26121 159.775 8.77504 161.805 12.7633 163.124Z"
                fill="#C3CCD9"
            />
            {sortedData?.map((item, index) => {
                const coor = coordinates[item.county];
                const dot = getDotSize(item.standingTime);
                if (coor && dot) {
                    return (
                        <circle
                            key={`circle-${coor.x}-${coor.y}-${index}`}
                            className={`circle-${dot} circle-border`}
                            cx={coor.x}
                            cy={coor.y}
                            r={radius.get(dot)}
                        />
                    );
                }
                return null;
            })}
        </svg>
    );
};

export default MapSvg;
